module.exports = __webpack_public_path__ + "static/media/camel.7112a04d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/camel.jpeg
// module id = 274
// module chunks = 0